import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { isEqual } from 'lodash-es';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { Feature, OtherRoomCommands, OtherRoomProperties } from '@vi-iot/client';

import {
  CommissioningStore,
  GatewayDeviceGroup,
  GatewayStore,
  InstallationFeaturesStore,
} from '@store';

import { AllAddedDevicesModalComponent } from '../../../../single-room-control/src-overlay/src-commissioning-overlay/commissioning-overview/all-added-devices-modal/all-added-devices-modal.component';
import { AllAddedRoomsModalComponent } from '../../../../single-room-control/src-overlay/src-commissioning-overlay/commissioning-overview/all-added-rooms-modal/all-added-rooms-modal.component';
import { matTooltipSetter } from '../../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';
import { ROOMS_FILTER_TYPE } from '../../commissioning/commissioning.model';
import { CommissioningService } from '../../commissioning/commissioning.service';

@Component({
  selector: 'app-commissioning-overview',
  templateUrl: './commissioning-overview.component.html',
  styleUrls: ['./commissioning-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissioningOverviewComponent implements OnInit, OnDestroy {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  notAssignedHCsToOtherRooms$: Observable<string[]>;
  otherRooms$: Observable<Feature<OtherRoomProperties, OtherRoomCommands>[]>;
  allAddedRoomsDialogRef: MatDialogRef<AllAddedRoomsModalComponent>;
  allAddedDevicesDialogRef: MatDialogRef<AllAddedDevicesModalComponent>;
  activeRoomsFilter: ROOMS_FILTER_TYPE = ROOMS_FILTER_TYPE.ALL;
  isAddRoomDisabled: boolean;
  isAddDeviceDisabled: boolean;
  unAssignableDevices$: Observable<GatewayDeviceGroup[]>;

  readonly filterType = ROOMS_FILTER_TYPE;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public gatewayStore: GatewayStore,
    public commissioningService: CommissioningService,
    public installationFeaturesStore: InstallationFeaturesStore,
    private dialog: MatDialog,
    private commissioningStore: CommissioningStore,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.installationFeaturesStore.isAddRoomDisabled$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((value) => {
        this.isAddRoomDisabled = value;
      });
    this.notAssignedHCsToOtherRooms$ = this.installationFeaturesStore.notAssignedHCsToOtherRooms$.pipe(
      distinctUntilChanged(isEqual)
    );
    this.otherRooms$ = this.installationFeaturesStore.otherRooms$.pipe(
      distinctUntilChanged(isEqual)
    );
    this.commissioningStore.isAddDeviceDisabled$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((value) => {
        this.isAddDeviceDisabled = value;
        this.cdr.detectChanges();
      });

    this.unAssignableDevices$ = this.gatewayStore.unAssignableDevices$.pipe(
      distinctUntilChanged(isEqual)
    );
  }

  onAddRoom(isAddingDisabled: boolean): void {
    if (!isAddingDisabled) {
      this.commissioningService.openAddRoomDialog();
    }
  }

  onAddDevice(): void {
    this.commissioningService.openAddDeviceDialog();
  }

  openAllAddedRoomsDialog(): void {
    this.allAddedRoomsDialogRef = this.dialog.open(AllAddedRoomsModalComponent, {
      width: '710px',
      panelClass: 'commissioning-all-added-rooms-dialog',
      data: {},
      disableClose: true,
      autoFocus: false,
    });
  }

  setFilter(filter: ROOMS_FILTER_TYPE): void {
    this.activeRoomsFilter = filter;
  }

  otherRoomNameTrackBy(index: number): number {
    return index;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
